<template lang='pug'>
  #dashboard
    .container
      TopMenu(v-if="showTopMenu" :nav-items="navItems")
    .container
      transition(name="fade" mode="out-in")
        router-view

</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import TopMenu from './TopMenu';

  export default {
    name: "Dashboard",
    
    components: { TopMenu },
    
    data() {
      return {
        isMounted: false,
        navItems: [
          { url: '/dashboard/welcome', text: 'Welcome' },
          { url: '/dashboard/purchases', text: 'Purchases' },
          { url: '/dashboard/account', text: 'Account' },
          { url: '/dashboard/shop', text: 'Shop' },
          { url: '/colorbar', text: 'Color Bar', out: true },
          { url: '/dashboard/how-to', text: 'How To' },
          { url: '/blog', text: 'Blog', out: true },
        ]
      }
    },

    computed: {
      ...mapState('customer', ['cdata']),

      showTopMenu() {
        return this.cdata.visitorType.toLowerCase() === 'return buyer';
      },
    },

    asyncComputed: {
      showWelcomeToRCDModal() {
        var shouldShowWelcomeToRCDModal = this.isMounted && this.cdata.visitorType.toLowerCase() === 'return buyer' && this.$root.advisorAnswers && !this.$root.advisorAnswers.welcomed_to_rcd;
        return new Promise(resolve => {
          if (shouldShowWelcomeToRCDModal) {
            this.$store.dispatch('modal/showModal', { component: './Dashboard/WelcomeToRCDModal' }, { root: true });
            return resolve(true);
          }
          resolve(false);
        });
      }
    },

    methods: {
      ...mapActions('customer', ['refreshCustomerCdata'])
    },

    created() {
      this.refreshCustomerCdata();
    },

    mounted() {
      this.isMounted = true;

      // periodically check timeout cookie and reload if expired
      setInterval(() => {
        if (!this.$cookies.get(this.$root.MRConfig.timeoutCookie)) {
          location.reload();
        }
      }, 1000 * 60 * 60 * 2); // 2 hours
    }
  }
</script>

<style scoped lang="stylus">
  #dashboard
    min-height 70vh
    
  .fade-enter-active,
  .fade-leave-active
    transition opacity .3s

  .fade-enter
    opacity 0

</style>
